import React from 'react';
import TagItem from './TagItem';
import { tags } from './mockData';
import './styles.scss';

const TagsFilter = () => {
    const [selectedName, setSelectedName] = React.useState('show all');
    const handleClick = name => setSelectedName(name);

    return (
        <div className="tags-filter">
            <TagItem name="show all" selectedName={selectedName} onClick={handleClick} />
            {tags.map(name => (
                <TagItem key={name} name={name} selectedName={selectedName} onClick={handleClick} />
            ))}
        </div>
    );
};

export default TagsFilter;
